





















































































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  dispatchType = "train/getTrainees";

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "姓名",
      dataIndex: "trainee_name"
    },
    {
      title: "电话",
      dataIndex: "user_mobile"
    },
    {
      title: "性别",
      scopedSlots: { customRender: "sex" }
    },
    // {
    //   title: '学员类型',
    //   dataIndex: 'trainee_type'
    // },
    {
      title: "教练",
      dataIndex: "coach_name"
    },
    {
      title: "场馆",
      dataIndex: "stadium_name"
    },
    // {
    //   title: '机构',
    //   dataIndex: 'institution_name'
    // },
    {
      title: "操作",
      scopedSlots: { customRender: "action" }
    }
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  mounted() {
    this.loadData();
  }
}
